import React, {useState} from 'react'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import {notification} from 'antd'
import Button from 'components/shared/Button'
import SelectPhotoAssets from 'components/shared/SelectPhotoAssets'
import './index.scss'

const chooseInputAssetsMutation = gql`
  mutation ChooseInputAssets($input: ChooseInputAssetsInput!, $productId: ID!) {
    ChooseInputAssets(input: $input) {
      product {
        id
      }
    }
    SubmitInput(productId: $productId) {
      product {
        id
        state
        requiresUserInput
        canProvideUserInput
      }
    }
  }
`

const ConfirmInputAssets = ({
  product,
  minQuantity,
  maxQuantity,
  descriptionText,
  getTotalCost,
}) => {
  const [prevProductId, setPrevProductId] = useState(product.id)
  const [selectedPhotos, setSelectedPhotos] = useState([])

  if (product.id !== prevProductId) {
    setSelectedPhotos([])
    setPrevProductId(product.id)
  }

  const photos = product.inputAssets.edges.map((e) => e.node)

  const hasSelectedPhotos = () => {
    const length = selectedPhotos.length
    return (length >= minQuantity) && (!maxQuantity || length <= maxQuantity)
  }

  const buttonAdditionalCost = () => {
    if (getTotalCost) {
      const cost = getTotalCost(selectedPhotos)
      return cost > 0 ? ` (+${cost}kr)` : ''
    }
    return ''
  }

  return (
    <div className="confirm-input-assets">
      {!!descriptionText && (
        <p>{descriptionText}</p>
      )}

      <SelectPhotoAssets
        product={product}
        photos={photos}
        minQuantity={minQuantity}
        maxQuantity={maxQuantity}
        selectedPhotos={selectedPhotos}
        onSelection={setSelectedPhotos}
      />

      <div className="actions">
        <Mutation
          mutation={chooseInputAssetsMutation}
          onCompleted={() => {
            notification['success']({
              message: 'Bilder valgt',
              description: 'Valgte bilder er nå sendt til redigering.',
            })
          }}
          onError={() => {
            notification['error']({
              message: 'Bildevalg feilet',
              description: 'Kunne ikke velge bilder grunnet en feil. Forsøk på nytt senere.',
            })
          }}
        >
          {(chooseInputAssets, {loading}) => {
            return (
              <Button
                type="action"
                loading={loading}
                disabled={!hasSelectedPhotos() || loading}
                onClick={() => {
                  chooseInputAssets({
                    variables: {
                      productId: product.id,
                      input: {
                        productId: product.id,
                        assets: selectedPhotos.map(p => ({assetId: p.id})),
                      }
                    }
                  })
                }}
              >
                <>Bekreft og fullfør{buttonAdditionalCost()}</>
              </Button>
            )
          }}
        </Mutation>
      </div>
    </div>
  )
}

export default ConfirmInputAssets
